import React from 'react';
import Image from '../../Image/Image';
import './style.scss';
export default class Donation extends React.PureComponent {
  render() {
    return (
      <Image
        src={`${process.env.REACT_APP_CLOUD_FRONT}/media/images/donation128x40.png`}
        aspectRatio={3}
        wrapperClassName={'donation'}
        title="Donation"
        alt="Donation"
      />
    );
  }
}
